import {Link} from "react-router-dom";
import {Pagination} from "react-bootstrap";
import {Add} from '@material-ui/icons'
import clsx from 'clsx'
import {useDispatch , useSelector} from "react-redux";
import {
    clearRevisionInternalTimer,
    goNthQuestionRevision,
    incrementRevisionTimer, setIntervalRevisionTimer,
    setVerifAnswerModeStatus
} from "../redux/actions/actions";
import {setHowmanyPaginationButtonsToClick} from "../redux/actions/actionsRecapitulatifs";
import { Button} from "react-bootstrap";

function Pag({size, gutter, variant, bg, circle}){
    let revision=useSelector(state=>state.revision);
    let items = [];
    const dispatch = useDispatch();
    let howManyQuestions =revision.data.questions ? revision.data.questions_count : 0;
    let nbButtons = Math.min(howManyQuestions , revision.howmanyPaginationButtonsToClick);
    for (let number = 0; number < nbButtons; number++) {
        let isCorrect= revision.userScore.filter(score=>score.questionIndex===number).length && revision.userScore.filter(score=>score.questionIndex===number)[0].correct;
        let isWrong =revision.userScore.filter(score=>score.questionIndex===number).length && !revision.userScore.filter(score=>score.questionIndex===number)[0].correct;
        let isActualCorrect=revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex).length && revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex)[0].correct;
        let isActualWrong= revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex).length && !revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex)[0].correct;
        let isActive= number===revision.actualQuestionIndex;
        items.push(
            <Pagination.Item onClick={()=>{
                    dispatch(goNthQuestionRevision(number));
                    if(!isActualCorrect && !isActualWrong){
                        // if it's not in verif mode then we have to clear the timer of the actual question
                        dispatch(clearRevisionInternalTimer())
                    }
                    if(!isCorrect && !isWrong){
                        // if the question we are going to : is not in verif mode then we have to increment its timer
                        const timerInterval =setInterval(()=>{
                            dispatch(incrementRevisionTimer(number))
                        },1000);
                        dispatch(setIntervalRevisionTimer(timerInterval));
                        // if the answer mode is toggled , it will be detetcted in the useEffect so it will  create a new  interval
                        if(revision.verifAnswerMode !==false){
                            dispatch(setVerifAnswerModeStatus(false));
                        }
                    }else{
                        if(revision.verifAnswerMode!==true){
                            dispatch(setVerifAnswerModeStatus(true));
                        }

                    }

                }}
                 key={number+1}
                 className={clsx({ actualProgressButton :isActive  ,correctProgressButton : isCorrect , wrongProgressButton : isWrong })}
            >
                {number+1}
            </Pagination.Item>
        );
    }
    return (
        <Pagination
            size={size}
            className={`mt-4 justify-content-center  ${gutter ? "pagination-gutter" : ""} ${
                variant && `pagination-${variant}`
            } ${!bg && "no-bg"} ${circle && "pagination-circle"}`}
        >
            {items}
            {/*the Plus button*/}
            { howManyQuestions > revision.howmanyPaginationButtonsToClick ?(
                <li className="page-item page-indicator">
                    <Button onClick={()=> dispatch(setHowmanyPaginationButtonsToClick(revision.howmanyPaginationButtonsToClick+revision.NbProgressionButtonsperClick))} className="page-link" to="#">
                        <Add style={{fontSize : '0.8rem'}}/>
                    </Button>
                </li>
            ) : null }

        </Pagination>
        )

};

export default Pag
